export const wiaInterfaceType = [
  {
    value: "G4SIM",
    label: "4G SIM",
  },
  {
    value: "G5SIM",
    label: "5G SIM",
  },
  {
    value: "RJ45",
    label: "RJ45",
  },
  {
    value: "LC",
    label: "LC",
  },
  {
    value: "SC",
    label: "SC",
  },
  {
    value: "ST",
    label: "ST",
  },
];
